import { ApiError, ErrorResponseDto } from '@pro4-erp/core-web';
import { AuditorCompetenceDetail } from '@/common';
import env from '@/env';

export const getAuditorCompetenceById = async (id: string): Promise<AuditorCompetenceDetail> => {
  const fetchResponse = await fetch(`${env.VITE_API_URL}/pb/s/api/sqo-portal/auditor-comps/${id}`, {
    method: 'GET',
    headers: {
      authenticate: localStorage.getItem('accessToken') || '',
    },
  });

  if (!fetchResponse.ok) {
    const error = (await fetchResponse.json()) as ErrorResponseDto;
    throw new ApiError(error);
  }

  const response = (await fetchResponse.json()) as AuditorCompetenceDetail;
  return response;
};
